import { render, staticRenderFns } from "./EmployeeCards_Share.vue?vue&type=template&id=fdc48ca6&scoped=true"
import script from "./EmployeeCards_Share.vue?vue&type=script&lang=js"
export * from "./EmployeeCards_Share.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCards_Share.vue?vue&type=style&index=0&id=fdc48ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc48ca6",
  null
  
)

export default component.exports